export enum TechnologyChargeType {
  Fixed = "Fixed",
  BasePlusUnits = "BasePlusUnits",
  Percentage = "Percentage",
}

export interface TechnologyUnit {
  id: number;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  createdBy?: { id: number; userName: string; displayName: string } | null;
}

export interface TechnologyRate {
  id: number;
  currencyId: number;
  unitCost: number;
  fixedAmount: number;
  baseAmount: number;
  percentage: number;
}

export interface LibraryTechnology {
  id: number;
  description: string;
  type: TechnologyChargeType;
  technologyUnitId: number;
  technologyUnit: TechnologyUnit;
  technologyRates: TechnologyRate[];
  createdAt: Date;
  updatedAt: Date;
  createdBy?: { id: number; userName: string; displayName: string } | null;
}

export interface TechnologyCharge {
  id: number;
  description: string;
  currencyId: number | null;
  fixedAmount: number;
  baseAmount: number;
  percentage: number;
  type: TechnologyChargeType;
  unitCost: number;
  technologyUnitId: number;
  technologyUnit: TechnologyUnit;
  createdAt: Date;
  updatedAt: Date;
  createdBy?: { id: number; userName: string; displayName: string } | null;
  units: number;
  order: number;
  matterId: number;
  libraryTechnologyId: number;
  libraryTechnology: LibraryTechnology;
  notes: string | null;
  autoFocus: boolean | null;
}
